import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { APP_CONFIG } from '@Core/config/app-config';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faInstagram, faXTwitter, IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationService } from '@Services/navigation.service';
import { FOOTER_CONST } from '@Utils/constants';
import { Subject, takeUntil } from 'rxjs';


@Component({
    selector: 'b2c-footer',
    imports: [CommonModule, TranslateModule, FontAwesomeModule],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnDestroy {

  private readonly config = inject(APP_CONFIG);

  public assetsContextRoot:string = this.config.contextRoot;

  public faTwitter: IconDefinition = faXTwitter;
  public faFacebook: IconDefinition = faFacebook;
  public faInstagram: IconDefinition = faInstagram;
  public footerConst = FOOTER_CONST;

  public isGroupPaymentPage: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(private navigationSvc: NavigationService){
    this.listenForGroupPage()
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private listenForGroupPage(){
    this.navigationSvc.isGroupPaymentPage
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe((isGroupPaymentPage: boolean) => {
      this.isGroupPaymentPage = isGroupPaymentPage;
    });
  }

}
